import { DefaultTheme } from 'styled-components';
import { acerta } from './acerta';
import { cipal } from './cipal';
import { liantis } from './liantis';
import { payflip } from './payflip';
import { payflipDark } from './payflip-dark';

export const themeNames = [
  'payflip',
  'liantis',
  'payflip-dark',
  'cipal',
  'acerta'
] as const;

export type ThemeName = (typeof themeNames)[number];

export function getTheme(themeName: ThemeName): DefaultTheme | null {
  switch (themeName) {
    case 'liantis': {
      return liantis;
    }
    case 'payflip-dark': {
      return payflipDark;
    }
    case 'payflip': {
      return payflip;
    }
    case 'cipal': {
      return cipal;
    }
    case 'acerta': {
      return acerta;
    }
    default: {
      return null;
    }
  }
}
